module.exports = __webpack_public_path__ + "static/media/testimonal17.225059b7.webp";